import ReactDOM from 'react-dom';
var ModalService = /** @class */ (function () {
    function ModalService() {
    }
    ModalService.prototype.open = function (component) {
        var el = document.createElement('div');
        document.body.appendChild(el);
        ReactDOM.render(component, el);
        return {
            component: component,
            close: function () {
                ReactDOM.unmountComponentAtNode(el);
                // document.body.removeChild(el);
            }
        };
    };
    return ModalService;
}());
export { ModalService };
//# sourceMappingURL=modal.service.js.map